import { FormikToggleSwitch } from "../../../../components/FormikFields/FormikToggleSwitch.js";
import { useSessionStorage } from "../../../../hooks/useSessionStorage.js";
import { useCurrentUserAnPCheck } from "../../../AuthWrapper2/hooks/useCurrentUserAnPCheck.js";
import "react";
import { FormLayout, Icon, Modal } from "@therms/atalaya";
import { IoMdDownload } from "react-icons/io";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
import * as Yup from "yup";
//#region src/modules/Locations/shared/LocationLogEntries/PickLocationLogEntryRefsModal.tsx
var ValidationSchema = Yup.object().shape({
	showEventsRefs: Yup.boolean(),
	showGpsCoords: Yup.boolean(),
	showInternalContent: Yup.boolean(),
	showLocationsRefs: Yup.boolean(),
	showRecordsRefs: Yup.boolean(),
	showReportsRefs: Yup.boolean(),
	showUsersRefs: Yup.boolean(),
	withRefHistory: Yup.boolean()
});
var initialValues = {
	showEventsRefs: false,
	showGpsCoords: false,
	showInternalContent: false,
	showLocationsRefs: false,
	showRecordsRefs: false,
	showReportsRefs: false,
	showUsersRefs: false,
	withRefHistory: false
};
function PickLocationLogEntryRefsModal({ closeHandler, onDownload }) {
	const [sessionValue, setSessionValue] = useSessionStorage("pickLogEntryOptions");
	const hasAccessToGpsCoords = useCurrentUserAnPCheck((user) => user.anp.role.portal.access.viewUserGps || user.anp.role.ops.access.viewOnDutyUsersGeoLocation);
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler,
		escPressClose: true,
		header: "Download Log Entry",
		outsideClickClose: true,
		width: "sm",
		children: /* @__PURE__ */ jsx(Formik, {
			initialValues: sessionValue || initialValues,
			onSubmit: (values) => {
				setSessionValue(values);
				onDownload(values);
			},
			ValidationSchema,
			children: ({ handleSubmit, values }) => /* @__PURE__ */ jsxs(FormLayout, {
				space: "xs",
				children: [
					/* @__PURE__ */ jsxs(FormLayout.Section, { children: [
						/* @__PURE__ */ jsx("div", {
							className: "text-color-subtle font-bold",
							children: "PDF Details"
						}),
						hasAccessToGpsCoords && /* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showGpsCoords,
							name: "showGpsCoords",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include GPS Coordinates?"
							})
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showInternalContent,
							name: "showInternalContent",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include Internal Content?"
							})
						})
					] }),
					/* @__PURE__ */ jsxs(FormLayout.Section, { children: [
						/* @__PURE__ */ jsx("div", {
							className: "text-color-subtle font-bold",
							children: "References"
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.withRefHistory,
							name: "withRefHistory",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include the Reference History?"
							}),
							subText: "A timestamped list of all references for this Log Entry."
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showEventsRefs,
							name: "showEventsRefs",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include Event References?"
							})
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showLocationsRefs,
							name: "showLocationsRefs",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include Location References?"
							})
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showRecordsRefs,
							name: "showRecordsRefs",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include Record References?"
							})
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showReportsRefs,
							name: "showReportsRefs",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include Report References?"
							})
						}),
						/* @__PURE__ */ jsx(FormikToggleSwitch, {
							active: values.showUsersRefs,
							name: "showUsersRefs",
							label: /* @__PURE__ */ jsx("div", {
								className: "text-color",
								children: "Include User References?"
							})
						})
					] }),
					/* @__PURE__ */ jsx("div", {
						className: "mt-sm",
						children: /* @__PURE__ */ jsx(FormLayout.Controls, {
							onSubmit: handleSubmit,
							submitLabel: /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Icon, {
								Icon: IoMdDownload,
								className: "mr-xxs"
							}), "Download"] })
						})
					})
				]
			})
		})
	});
}
//#endregion
export { PickLocationLogEntryRefsModal };

//# sourceMappingURL=PickLocationLogEntryRefsModal.js.map